import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.num = _this.value; // 所选商品数量
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "isGray",
    get: function get() {
      return this.num === 1;
    }
  }, {
    key: "reduce",
    value: function reduce() {
      if (this.num !== 1 && !this.isGray && !this.readonly) {
        this.num -= 1;
        this.$emit('update:value', this.num);
        this.$emit('change', this.num);
        this.$emit('reduce', this.num);
      }
    }
  }, {
    key: "add",
    value: function add() {
      if (this.num <= this.max && !this.readonly) {
        this.num += 1;
        this.$emit('update:value', this.num);
        this.$emit('change', this.num);
        this.$emit('add', this.num);
      }
    }
  }, {
    key: "numchange",
    value: function numchange(e) {
      var v = e.target.value;
      if (v > this.max) v = this.max;
      if (v < this.minNum) v = this.minNum;
      this.num = v;
      this.$emit('update:value', this.num);
      this.$emit('change', this.num);
      this.$emit('numchange', this.num);
    }
  }]);
}(Vue);
__decorate([Prop({
  default: ''
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  default: 1
})], default_1.prototype, "minNum", void 0);
__decorate([Prop({
  default: Infinity
})], default_1.prototype, "max", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "readonly", void 0);
default_1 = __decorate([Component({
  name: 'Stepper'
})], default_1);
export default default_1;